import React from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import "./html.css"
import { Link } from 'react-router-dom';
import Arrow from "../../../assets/images/Services/right-arrow.png";

import SEO from '../../seo';

export default function Html() {
        const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ]; 
    return (
        <div className='product-brand'>
              <SEO
                title="HTML/CSS"
                description="Technology Crafting Exceptional Websites with HTML/CSS! At Horizon WebInfo Pvt Ltd, we believe in the power of innovation and seamless digital experiences. Our expertise lies in harnessing the potential of HTML and CSS to create stunning, responsive websites that captivate audiences and drive results. Why HTML/CSS? HTML: The Foundation of Web Development HTML (HyperText Markup [&hellip;]"
                canonical="https://www.hwplindia.com/technology/html-css/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2024/01/erp-crm-development-company-banner-img.png"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>HTML/CSS</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li><Link to="/technology">Technology</Link></li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>HTML/CSS</li>
                    </ul>
                </div>
            </section>
            <section className="ai-ml-main">
                <div className='ai-ml-container'>
                    {/* Content Section */}
                    <div className="branding-content">
                        {/* CTA */}
                        <section className="cta-section">
                            <span className='tech'>Technology</span>
                            <h3 className='tech-h3'>Crafting Exceptional Websites with HTML/CSS!</h3>
                            <p className='email'>
                                At Horizon Webinfo Pvt. Ltd. we believe in the power of innovation and seamless digital experiences. Our expertise lies in harnessing the potential of HTML and CSS to create stunning, responsive websites that captivate audiences and drive results.
                            </p>
                        </section>

                        <section className="cta-section it-consult">
                            <h3 className='cta-section-business-process ai-ml-heading'>Why HTML/CSS?</h3>
                        </section>

                        {/* Sections */}
                        <section className='it-consult'>
                            <section className="branding-item ">
                                <h4><img src={Arrow} />HTML: The Foundation of Web Development</h4>
                                <p>
                                    HTML (HyperText Markup Language) serves as the backbone of the internet. It structures web content, defining the layout, format, and presentation of information across browsers. Our adept developers leverage the latest HTML standards to build websites that are not only visually appealing but also functionally robust. With a keen eye on accessibility and SEO best practices, we ensure your website reaches its maximum potential.
                                </p>
                            </section>

                            <section className="branding-item">
                                <h4><img src={Arrow} />CSS: Elevating Design & User Experience</h4>
                                <p>
                                    Cascading Style Sheets (CSS) are instrumental in enhancing the aesthetics and usability of websites. Our team masters CSS intricacies to craft visually stunning and intuitively designed interfaces. From fluid layouts to engaging animations, we utilize CSS to create dynamic and responsive web designs that adapt flawlessly to various devices and screen sizes.
                                </p>
                            </section>

                            {/* Heading Desc */}
                            <section className="why-choose ai-ml-sec">
                                <h3>Our HTML/CSS Expertise :</h3>
                                <h2 className='ai-ml-title'>Responsive Design</h2>
                                <p>Crafting websites that seamlessly adjust to any screen size, providing an optimal viewing experience across devices.</p>
                                <h2 className='ai-ml-title'>Customization</h2>
                                <p>Tailoring unique designs and functionalities to align with your brand identity and specific business goals.</p>
                                <h2 className='ai-ml-title'>Performance Optimization</h2>
                                <p>Implementing efficient coding practices to ensure swift load times and smooth user interactions.</p>
                                <h2 className='ai-ml-title'>Cross-Browser Compatibility</h2>
                                <p>Ensuring consistent performance across different browsers for a wider audience reach.</p>
                                <h2 className='ai-ml-title'>SEO-Friendly Approach</h2>
                                <p>Implementing SEO best practices during development to enhance visibility and ranking on search engines.</p>
                            </section>


                            {/* CTA */}
                            <section className="cta-section">
                                <h3>Collaborate with Us</h3>
                                <p>
                                    At Horizon Webinfo Pvt. Ltd. we blend creativity with technical prowess to transform your vision into a captivating digital presence. Whether you’re a startup aiming for a remarkable debut or an established enterprise seeking a website revamp, our HTML/CSS expertise is geared to meet your unique requirements. <br />
                                    Let’s embark on a journey to create a website that not only meets but exceeds your expectations. Contact us today to explore the boundless possibilities of HTML/CSS in web development.
                                </p>
                                {/* <Link to="/contact" className="quote-btn1-brand">
                                    <span><i aria-hidden="true" class="fas fa-external-link-alt"></i> ENQUIRY NOW</span>
                                </Link> */}
                            </section>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    );
}